import { Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import CancelButton from '../button/CancelButton';
import SubmitButton from '../button/SubmitButton';

const ConfirmDialog = ({ title, content, confirmText, onConfirm, open, onClose }) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    setLoading(true);
    onConfirm()
      .then()
      .finally(() => {
        onClose(true);
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <div>{content}</div>
          <Stack direction="row" justifyContent="end" spacing={1}>
            <CancelButton onClick={() => onClose(false)} />

            <SubmitButton disabled={loading} onClick={onSubmit} color="error">
              {confirmText}
              {loading && <CircularProgress size={14} sx={{ ml: 1 }} />}
            </SubmitButton>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
